// dependencies
import { fromJS, isImmutable } from "immutable";
import moment from "moment";

// utils
import get from "../../utils/GetNested";

export const getParamType = (paramName, configuration) => {
	let configType = "";
	configuration.forEach((config) => {
		if (config.param === paramName) {
			configType = config.type;
		}
	});
	return configType;
};

/**
 * The purpose of this function is to extend our parsed value objects
 * with immutable objects for easy implementation with our immutable components
 */
export const translateImmutableValues = (parsedValues) => {
	const immutableParsedValues = parsedValues.map((item) => {
		const { value, type } = item;

		let immutableValue = value;

		switch (type) {
			case "userID": {
				immutableValue = fromJS(value);
				break;
			}

			case "userIDs": {
				immutableValue = fromJS(value);
				break;
			}

			case "multiSelect": {
				immutableValue = fromJS(value);
				break;
			}

			case "goalPicker": {
				immutableValue = fromJS(value);
				break;
			}

			case "goalOutlook": {
				immutableValue = fromJS(value);
				break;
			}

			case "goalCategory": {
				immutableValue = fromJS(value);
				break;
			}

			case "formPicker": {
				immutableValue = fromJS(value);
				break;
			}

			default: {
				break;
			}
		}

		return {
			...item,
			immutableValue,
		};
	});

	return immutableParsedValues;
};

/**
 * Transforms the updates to strings that can be inserted into the query params.
 * @param {*} updates
 * @param {*} configuration
 * @param {*} parsedQueryString
 */
export const translateUpdatesToStrings = (updates, configuration) => {
	const stringifiedParams = {};

	updates.forEach((update) => {
		const updateType = getParamType(update.param, configuration);
		let queryParamValue = update.value;

		switch (updateType) {
			// takes in either an immutable object with user
			// name and id,string with user id, or object with
			// user name and id

			case "userID": {
				if (isImmutable(update.value)) {
					queryParamValue = update.value.get("id");
				} else if (update?.value?.id) {
					queryParamValue = update.value?.id;
				}
				break;
			}
			// multiple users (either an immutable List or array)
			case "userIDs": {
				if (isImmutable(update.value)) {
					queryParamValue = update.value.map((user) => user.get("id")).toJS();
				} else {
					queryParamValue = update.value.map((user) => user.id);
				}
				break;
			}
			//
			case "date": {
				if (moment.isMoment(update.value)) {
					queryParamValue = moment(update.value).format();
				}
				break;
			}

			case "goalCategory": {
				const goalCategory = isImmutable(update.value) ? update.value.toJS() : update.value;

				const poolValues = get(goalCategory, ["pool"], []);

				const poolIDs = poolValues.map((item) => item.id);
				queryParamValue = poolIDs;

				break;
			}

			case "goalOutlook": {
				const goalOutlook = isImmutable(update.value) ? update.value.toJS() : update.value;

				const poolValues = get(goalOutlook, ["pool"], []);

				const poolIDs = poolValues.map((item) => item.id);
				queryParamValue = poolIDs;

				break;
			}

			case "goalPicker": {
				queryParamValue = update.value?.value;
				break;
			}

			case "formPicker": {
				const form = isImmutable(update.value) ? update.value.toJS() : update.value;
				queryParamValue = get(form, ["id"], "");
				break;
			}

			case "multiSelect": {
				if (isImmutable(update.value)) {
					if (update.value.size > 0) {
						queryParamValue = update.value.toJS();
					} else {
						queryParamValue = "";
					}
				} else if (!isImmutable(update.value) && update.value.length > 0) {
					queryParamValue = update.value;
				} else {
					queryParamValue = "";
				}
				break;
			}

			case "checkbox": {
				if (update.value === true) {
					queryParamValue = true;
				} else {
					queryParamValue = "";
				}
				break;
			}
			default: {
				queryParamValue = update.value;
			}
		}

		stringifiedParams[update.param] = queryParamValue;
	});

	return stringifiedParams;
};
